<template>
    <div>


        <ul class="nav nav-tabs"
            id="myTab"
            role="tablist">
            <li v-for="(year, index) in this.getYears"
                class="nav-item"
                role="presentation">
                <button class="nav-link"
                    :class="index == 0 ? 'active': ''"
                    :id="getYearButtonId(year)"
                    data-toggle="tab"
                    :data-target="getTarget(year)"
                    type="button"
                    role="tab"
                    :aria-controls="year"
                    :aria-selected="index == 0 ? true : false">{{year}}</button>
            </li>

        </ul>
        <div class="tab-content"
            id="priceTabContent">

            <div v-for="(year, index) in this.getYears"
                class="tab-pane fade"
                :class="index == 0 ? 'show active' : ''"
                :id="getTabId(year)"
                role="tabpanel"
                :aria-labelledby="getTabAreaLabel(year)">
                <table class="table pricelist table-hover">
                    <thead>
                        <tr class="subrow">
                            <th>Saison</th>
                            <th>Zeitraum</th>
                            <th class="text-right">Preis</th>
                        </tr>
                    </thead>

                    <tbody v-for="sg in priceArray">

                        <tr v-for="price in sg.lines"
                            v-if="sg.service.type == 'RENT' && price.condition.minDays >= 3 && price.value > 0 && price.fromdate && isDateInRange(price.fromdate, year)"
                            class="subrow">
                            <td class="subinfo align-top">
                                <span>{{price.description.de}}</span>
                                <br/>
                            </td>
                            <td><span v-if="price.fromdate">{{getFormattedDate(price.fromdate)}} - {{getFormattedDate(price.tilldate)}}</span>
                                <!--    <br /><span>zzgl. einmaliger Nebenkosten</span>-->
                            </td>
                            <td class="text-right align-top">
                                <span>ab {{getCalculatedPrice(price.value)}}  pro Nacht</span>
                                <!-- <br/>{{getFinalCleaningBySeason(price.season)}}
                                <price-help></price-help>-->
                            </td>

                        </tr>

                        <!--<tr v-for="price in sg.lines"
                            v-if="sg.service.type == 'VTAX' && price.fromdate && isDateInRange(price.fromdate, year) && price.value > 0"
                            class="subrow">
                            <td class="subinfo align-top">
                                <span>{{price.season}}</span>
                                <br/>
                            </td>
                            <td><span v-if="price.fromdate">{{getFormattedDate(price.fromdate)}} - {{getFormattedDate(price.tilldate)}}</span>
                            </td>
                            <td class="text-right align-top">
                                <span>ab {{getCalculatedPrice(price.value)}}</span>
                            </td>

                        </tr>-->
                    </tbody>


                </table>
            </div>
        </div>

    </div>
</template>
<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'price-tab',
    	props: {
    		pricelist: String
    	},
    	data: function() {
    		return {
    			priceArray: {},
    			unitId: Number,
    			priceBookingFee: Number,
    			priceFinalCleaning: Number
    		};
    	},
    	mounted: function() {
    		var pricelist = JSON.parse(this.pricelist);
    		this.priceArray = pricelist;

    		console.log('Mounted@Pricelist::', pricelist);
    		var years = [];

    		var i, j;
    		this.priceFinalCleaning = 0;
    		this.priceBookingFee = 0;
    		//console.log('pricelist::' + pricelist);
    		for (i = 0; i < pricelist.length; i++) {

    			//console.log('looping through pricelist...')

    			/*console.log('type::' + pricelist[i].service.type);
    			console.log('value:' + pricelist[i].value);
    			console.log('price:' + pricelist[i].price);*/

    			if (pricelist[i].service.type && pricelist[i].service.type === 'FINALCLEANING') {
    				//console.log('Type::', pricelist[i].service.type, 'Price::', pricelist[i].price);
    				this.priceFinalCleaning = pricelist[i].price;
    			}
    			if (pricelist[i].service.type && pricelist[i].service.type === 'BOOKING_FEE') {
    				//console.log('Type::', pricelist[i].service.type, 'Price::', pricelist[i].price);
    				this.priceBookingFee = pricelist[i].price;
    			}
    			for (j = 0; j < pricelist[i].lines.length; j++) {
    				//console.log('inside loop date::' + pricelist[i].lines[j].fromdate);
    				if (pricelist[i].lines[j].fromdate) {
    					var year = pricelist[i].lines[j].fromdate.substring(0, 4);
    					//console.log('year is::' + year);
    					if (years.indexOf(year) < 0) {
    						years.push(year);
    					}
    				}
    			}
    		}
    		//	console.log('years::' + years);
    		/*console.log('this.pricelist::' + this.pricelist); */
    	},
    	methods: {
    		getYearButtonId: function(year) {
    			return 't' + year + '-tab';
    		},
    		getTarget: function(year) {
    			return "#t" + year;
    		},
    		getTabId: function(year) {
    			return "t" + year;
    		},
    		getTabAreaLabel: function(year) {
    			return "t" + year + "-tab";
    		},
    		getFormattedDate: function(date) {
    			return DateEx.formatDate(date, 'dd.MM.yy', 'de');
    		},
    		getCalculatedPrice: function(price) {
    			var rentPrice = 0;
    			var calcPrice = 0;
    			if (price > 0) {
    				rentPrice = price;
    				calcPrice = Number((rentPrice) / 100).toLocaleString("de-DE", {
    					minimumFractionDigits: 2
    				}) + " €";
    			}
    			return calcPrice;
    		},
    		getFinalCleaningBySeason: function(seasonName) {
    			var calcPrice = '';
    			var pricelist = JSON.parse(this.pricelist);
    			for (var i = 0; i < pricelist.length; i++) {

    				/*console.log('looping through pricelist...')

    				console.log('type::' + pricelist[i].service.type);
    				console.log('value:' + pricelist[i].value);
    				console.log('price:' + pricelist[i].price);*/

    				if (pricelist[i].service.type && pricelist[i].service.type === 'FINALCLEANING') {
    					if (pricelist[i].lines) {
    						for (var j = 0; j < pricelist[i].lines.length; j++) {
    							if (pricelist[i].lines[j].season == seasonName && pricelist[i].lines[j].value > 0) {
    								calcPrice = Number((pricelist[i].lines[j].value) / 100).toLocaleString("de-DE", {
    									minimumFractionDigits: 2
    								}) + " €";
    							}
    						}
    					}

    				} else if (pricelist[i].price > 0) {
    					calcPrice = Number((pricelist[i].price) / 100).toLocaleString("de-DE", {
    						minimumFractionDigits: 2
    					}) + " €";
    				}
    			}
    			//console.log('Returning final cleaning:' + calcPrice);
    			return calcPrice;
    		},
    		getCalculatedMandatoryPrice: function() {
    			/*console.log('this.priceBookingFee:' + this.priceBookingFee);
    			console.log('this.priceFinalCleaning:' + this.priceFinalCleaning);*/
    			var bookingFee = this.priceBookingFee ? this.priceBookingFee : 0;
    			var cleaningFee = this.priceFinalCleaning ? this.priceFinalCleaning : 0;
    			//console.log("bookingfee::" + bookingFee);
    			//console.log('cleaningFee::' + cleaningFee);
    			var calcPrice = 0;
    			calcPrice = Number((bookingFee + cleaningFee) / 100).toLocaleString("de-DE", {
    				minimumFractionDigits: 2
    			}) + " €";

    			return calcPrice;
    		},
    		isDateInRange: function(fromdate, year) {
    			if (!fromdate) {
    				return true;
    			}
    			var fromYear = parseInt(fromdate.substring(0, 4));
    			if (fromYear == year) {
    				return true;
    			}
    			return false;
    		}

    	},
    	computed: {
    		getYears: function() {
    			var pricelist = JSON.parse(this.pricelist);

    			//console.log('Pricelist::', pricelist);
    			var years = [];

    			var i, j;
    			for (i = 0; i < pricelist.length; i++) {
    				for (j = 0; j < pricelist[i].lines.length; j++) {
    					if (pricelist[i].lines[j].fromdate) {
    						var year = pricelist[i].lines[j].fromdate.substring(0, 4);
    						if (years.indexOf(year) < 0) {
    							years.push(year);
    						}
    					}
    				}
    			}
    			return years;
    		}
    	}
    };
</script>